(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onyra-annonce"] && !Shopify.designMode) return;
  try {
    
  class OnyraAnnonce extends HTMLElement {
    connectedCallback() {
      this.msgs = Array.from(this.querySelectorAll('.o-annonce__msg'));
      if (!this.hasAttribute('data-rotation') || this.msgs.length < 2) return;
      this.index = 0;
      this.demarrer();
      this.surSelection = (event) => {
        const k = this.msgs.indexOf(event.target);
        if (k < 0) return;
        clearInterval(this.minuteur);
        this.montrer(k);
      };
      this.surDeselection = () => this.demarrer();
      document.addEventListener('shopify:block:select', this.surSelection);
      document.addEventListener('shopify:block:deselect', this.surDeselection);
    }

    disconnectedCallback() {
      clearInterval(this.minuteur);
      document.removeEventListener('shopify:block:select', this.surSelection);
      document.removeEventListener('shopify:block:deselect', this.surDeselection);
    }

    demarrer() {
      clearInterval(this.minuteur);
      const secondes = parseInt(this.dataset.vitesse, 10) || 5;
      this.minuteur = setInterval(() => this.montrer(this.index + 1), secondes * 1000);
    }

    montrer(k) {
      this.index = k % this.msgs.length;
      this.msgs.forEach((msg, j) => {
        const actif = j === this.index;
        msg.classList.toggle('is-actif', actif);
        msg.setAttribute('aria-hidden', actif ? 'false' : 'true');
      });
    }
  }
  if (!customElements.get('onyra-annonce')) customElements.define('onyra-annonce', OnyraAnnonce);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onyra-header"]) return;
  try {
    
  class OnyraMenu extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.bouton = this.details.querySelector('summary');
      this.bouton.addEventListener('click', (event) => {
        event.preventDefault();
        this.details.open ? this.fermer() : this.ouvrir();
      });
      this.querySelectorAll('.o-menu__fermer, .o-menu__voile').forEach((el) => el.addEventListener('click', () => this.fermer()));
      this.querySelectorAll('.o-menu__panneau a').forEach((a) => a.addEventListener('click', () => this.fermer(false)));
      this.details.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') this.fermer();
      });
    }

    ouvrir() {
      this.details.open = true;
      this.bouton.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('o-sans-defilement');
      requestAnimationFrame(() => requestAnimationFrame(() => this.details.classList.add('is-ouvert')));
      const fermer = this.querySelector('.o-menu__fermer');
      if (fermer) setTimeout(() => fermer.focus(), 50);
    }

    fermer(rendreFocus = true) {
      if (!this.details.open) return;
      this.details.classList.remove('is-ouvert');
      this.bouton.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('o-sans-defilement');
      const fin = () => {
        this.details.open = false;
        if (rendreFocus) this.bouton.focus();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) fin();
      else setTimeout(fin, 300);
    }
  }
  if (!customElements.get('onyra-menu')) customElements.define('onyra-menu', OnyraMenu);

  class OnyraRecherche extends HTMLElement {
    connectedCallback() {
      this.bouton = this.querySelector('[data-recherche-bouton]');
      this.panneau = this.querySelector('.o-recherche__panneau');
      this.champ = this.querySelector('input[type="search"]');
      this.bouton.addEventListener('click', () => (this.panneau.hidden ? this.ouvrir() : this.fermer()));
      this.querySelector('[data-recherche-fermer]').addEventListener('click', () => this.fermer());
      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') this.fermer();
      });
      document.addEventListener('click', (event) => {
        if (!this.panneau.hidden && !this.contains(event.target)) this.fermer(false);
      });
    }
    ouvrir() {
      this.panneau.hidden = false;
      this.bouton.setAttribute('aria-expanded', 'true');
      setTimeout(() => this.champ.focus(), 30);
    }
    fermer(rendreFocus = true) {
      if (this.panneau.hidden) return;
      this.panneau.hidden = true;
      this.bouton.setAttribute('aria-expanded', 'false');
      if (rendreFocus) this.bouton.focus();
    }
  }
  if (!customElements.get('onyra-recherche')) customElements.define('onyra-recherche', OnyraRecherche);

  } catch(e) { console.error(e); }
})();
})();
